const MEILISEARCH_HOST = 'https://meilisearch.staging.netlive.ch'
const MEILISEARCH_API_KEY = 'ebe3dfac-c331-4c27-9b39-7e977e4803b5'

export {
  MEILISEARCH_HOST,
  MEILISEARCH_API_KEY
}
